// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__29eTe","checkboxCol":"Table_checkboxCol__1KrvH","emailCol":"Table_emailCol__22vK7","actionCol":"Table_actionCol__2_Tme"};